document.addEventListener('DOMContentLoaded', function () {
    const cartDrawer = document.getElementById('cart-drawer');
    const cartOverlay = document.getElementById('cart-overlay');
    const cartInner = document.getElementById('cart-drawer-inner');

    let listenersAdded = false;
    let freeGiftLockedThisOpen = false;

    function openCartDrawer() {
      console.log('Opening cart drawer');
        freeGiftLockedThisOpen = false;

        // Add cart event listener
        addEventListeners();

        // Drop chat button z-index
        const gorgiasBtn = document.getElementById('chat-button');
        if (gorgiasBtn) gorgiasBtn.style.zIndex = '1';

        // Show drawer and overlay immediately
        cartDrawer.classList.add('open');
        cartOverlay.classList.remove('hidden');
        cartOverlay.classList.add('visible');
        document.body.classList.add('no-scroll');

        // Then load cart content
        fetchCartContent();
    }
    window.openCartDrawer = openCartDrawer; // Expose function globally. Used in cart-notification.js to open the drawer.
    
    function closeCartDrawer() {
        cartDrawer.classList.remove('open');
        cartOverlay.classList.remove('visible');
        cartOverlay.classList.add('hidden');
        cartInner.innerHTML = ''; // Clear content

        document.body.classList.remove('no-scroll');
        // Restore chat button z-index
        const gorgiasBtn = document.getElementById('chat-button');
        if (gorgiasBtn) gorgiasBtn.style.zIndex = '2147483636';
    }

    function fetchCartContent() {
      console.log('Fetching cart content');
      fetch('/?section_id=cart-drawer')
        .then(res => res.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.getElementById('shopify-section-cart-drawer');
          if (!content) return;

          // Inject cart content
          cartInner.innerHTML = content.innerHTML;
            
          setTimeout(() => {
            document.querySelectorAll('.cart-drawer__cross-sells-wrapper')
              .forEach(wrapper => updateCrossSellNavState(wrapper));
          }, 50);

          // Auto-focus checkout button and init shipping
          const checkoutBtn = cartDrawer.querySelector('#checkout');
          if (checkoutBtn) {
            checkoutBtn.focus();
            //initShippingCalculator();
            initFreeGiftOffers();
          }

          updateCartIconCount();
        });
    }
    
    function updateCartIconCount() {
      const countBubble = document.querySelector('.cart-count-bubble');
      if (!countBubble) return;

      let count = 0;
      const subtotalRow = document.querySelector('.cart-drawer__row--subtotal');
      if (subtotalRow) {
        // Get items count from the subtotal row
        count = subtotalRow.dataset.itemsCount || 0;
      } 

      const spanVisible = countBubble.querySelector('span[aria-hidden="true"]');
      const spanScreenReader = countBubble.querySelector('span.visually-hidden');

      if (spanVisible) spanVisible.innerText = count;
      if (spanScreenReader) spanScreenReader.innerText = `${count} item${count === 1 ? '' : 's'}`;
    
    }

    // Bind to cart icon
    const cartTrigger = document.querySelector('[data-drawer-toggle="cart"]');
    if (cartTrigger) {
        cartTrigger.addEventListener('click', function (e) {
            e.preventDefault();
            openCartDrawer();
        });
    }

    function addEventListeners() {
      if (listenersAdded) return;
      listenersAdded = true;

      // Overlay click closes drawer
      cartOverlay.addEventListener('click', closeCartDrawer);

      // Header close button click closes drawer
      document.addEventListener('click', function (e) {
          if (e.target.id === 'cart-drawer-close') {
              closeCartDrawer();
          }
      });

      // ESC key closes drawer
      document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && cartDrawer.classList.contains('open')) {
              closeCartDrawer();
          }
      });

      // Trap focus inside cart drawer when open
      document.addEventListener('keydown', function (e) {
          if (!cartDrawer.classList.contains('open')) return;

          const focusableSelectors = [
              'a[href]',
              'button:not([disabled])',
              'textarea:not([disabled])',
              'input:not([disabled])',
              'select:not([disabled])',
              '[tabindex]:not([tabindex="-1"])'
          ];
          const focusableElements = cartDrawer.querySelectorAll(focusableSelectors.join(', '));
          if (focusableElements.length === 0) return;

          const first = focusableElements[0];
          const last = focusableElements[focusableElements.length - 1];

          // Trap Tab key
          if (e.key === 'Tab') {
              if (e.shiftKey && document.activeElement === first) {
                  e.preventDefault();
                  last.focus();
              } else if (!e.shiftKey && document.activeElement === last) {
                  e.preventDefault();
                  first.focus();
              }
          }
      });

      // Handle remove item clicks
      document.addEventListener('click', function (e) {
        const removeBtn = e.target.closest('.cart-drawer__remove');
        if (!removeBtn) return;

        e.preventDefault();
        removeBtn.classList.add('cart-drawer__remove--loading');

        const line = removeBtn.getAttribute('data-line');

        // Disable all remove buttons
        document.querySelectorAll('.cart-drawer__remove').forEach(btn => btn.disabled = true);

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: 0 })
        })
          .then(res => res.json())
          .then(() => {
            fetchCartContent();
            document.querySelectorAll('.cart-drawer__remove').forEach(btn => btn.disabled = false);
          });
      });

      // Handle quantity changes
      document.addEventListener('change', function (e) {
          if (e.target.matches('.cart-drawer__quantity-select')) {
              const line = e.target.getAttribute('data-line');
              const quantity = parseInt(e.target.value, 10);

              fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ line: Number(line), quantity: quantity })
              })
                  .then(res => res.json())
                  .then(() => {
                      // Refresh cart drawer
                      fetchCartContent();
                  });
          }
      });

      // Order references
      document.addEventListener('click', function (e) {
        if (e.target.matches('.edit-order-reference')) {
          e.preventDefault();
          const itemKey = e.target.getAttribute('data-order-ref-key');
          const currentReference = e.target.getAttribute('data-order-ref-value') || '';

          editOrderReference(itemKey, currentReference);
        }
      });
      async function editOrderReference(itemKey, currentReference) {
          const input = prompt("Add, edit or remove your order reference(s):", currentReference);
          if (input === null) {
              // User cancelled the prompt, do nothing
              return;
          }

          const newReference = input?.trim();

          // Fetch the cart to get the line item by key
          const cart = await fetch('/cart.js').then(res => res.json());
          const lineItem = cart.items.find(item => item.key === itemKey);
          if (!lineItem) {
              return;
          }

          const existingProperties = { ...(lineItem.properties || {}) };
          if (!newReference || newReference === '') {
              existingProperties['Order Reference(s)'] = "";
          } else {
              existingProperties['Order Reference(s)'] = newReference;
          }

          //console.log('Existing properties:', JSON.stringify(existingProperties, null, 2));

          const updates = {'id': itemKey, 'quantity': lineItem.quantity, 'properties': existingProperties};

          // Perform the fetch request
          fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(updates)
          })
          .then(response => {
              if (response.ok) {
                  return response.json();
              } else {
                  throw new Error(`Cart line item properties update failed. ${response.statusText} ${response.status}`);
              }
          })
          .then((data) => {
              openCartDrawer(); // Refresh the cart drawer
          })
          .catch((error) => {
              console.error('Error:', error, JSON.stringify(updates));
          });
      }

      // Postcode input & change event
      document.addEventListener('input', function (e) {
        if (e.target.matches('.cart-drawer__postcode-input')) {
          // Handle input event for postcode
          e.target.value = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
          if (e.target.value.length > 4) {
            e.target.value = e.target.value.slice(0, 4); // Limit to 4 characters
          }
        }
      });

      document.addEventListener('change', async function (e) {
        if (e.target.matches('.cart-drawer__postcode-input')) {
          e.preventDefault();

          const shippingCost = document.querySelector('.cart-drawer__shipping-cost'); 
          if (shippingCost) {
            shippingCost.classList.add('shimmer');  
            shippingCost.innerText = '&nbsp;'; // Show shimmer effect}
          }
          
          // Handle change event for postcode
          const postcode = e.target.value;

          // Save postcode to local storage
          address.zip = postcode;
          address.city = null; // Reset city as postcode has changed
          address.province = null; // Reset province as postcode has changed
          address.country = null; // Reset country as postcode has changed  

          await getPostcodeDetails(postcode);
          addressIsComplete = () => address.city?.trim() && address.zip?.trim() && address.province?.trim() && address.country?.trim();
          if (addressIsComplete()) {
            getShippingRates(address);
          } 
          else {
            // Display postcode input box
            document.querySelector('.cart-drawer__row--shipping-postcode').classList.remove('hidden');
            const shippingCost = document.querySelector('.cart-drawer__shipping-cost'); 
            if (shippingCost) {
              shippingCost.classList.remove('shimmer');  
              shippingCost.innerText = 'Enter a valid postcode';
              renderRates([]); // Clear rates display
            }
          }
        }
      });

      // 🚀 ENTER key triggers 'change' manually
      document.addEventListener('keydown', function (e) {
        if (e.target.matches('.cart-drawer__postcode-input') && e.key === 'Enter') {
          e.preventDefault();
          const changeEvent = new Event('change', { bubbles: true });
          e.target.dispatchEvent(changeEvent);
        }
      });

      document.addEventListener('click', async function (e) {
        const btn = e.target.closest('[data-cross-sell-add]');
        if (!btn) return;

        e.preventDefault();

        if (btn.classList.contains('is-loading') || btn.disabled) return;

        btn.classList.add('is-loading');

        try {
          await addCrossSellVariant(btn.dataset.variantId, btn.dataset.crossSellPosition);
          fetchCartContent(); // Re-render cart drawer so item disappears from cross-sells
        } catch (error) {
          console.error('Cross-sell add failed', error);
          btn.classList.remove('is-loading');
        }
      });
      document.addEventListener('click', function (e) {
        const nav = e.target.closest('[data-cross-sell-nav]');
        if (!nav) return;
        const direction = nav.dataset.crossSellNav;
        const wrapper = nav.closest('.cart-drawer__cross-sells-wrapper');
        if (!wrapper) return;
        const track = wrapper.querySelector('[data-cross-sell-track]');
        if (!track) return;

        // Scroll amount = ~1 card width
        const card = track.querySelector('.cart-drawer__cross-sell-card');
        if (!card) return;

        const scrollAmount = card.offsetWidth + 12; // 12 = gap

        if (direction === 'right') {
          track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }
      });
      document.addEventListener('scroll', function (e) {
        const track = e.target.closest('[data-cross-sell-track]');
        if (!track) return;

        const wrapper = track.closest('.cart-drawer__cross-sells-wrapper');
        if (!wrapper) return;

        updateCrossSellNavState(wrapper);
      }, true);

    }

    ////////////////////////////////////////////////////////
    // Free Gift – show offer when eligible, add on click
    ////////////////////////////////////////////////////////
    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function eligibleSubtotalCents(cart, excludedVariantId) {
      return cart.items.reduce((sum, item) => {
        if (Number(item.variant_id) === Number(excludedVariantId)) return sum;
        return sum + item.final_line_price; // cents
      }, 0);
    }

    function normalizeDiscountTitle(title) {
      return String(title || '').trim().toLowerCase();
    }

    function nonStackableDiscountTitles(offer) {
      const freeGiftWrapper = offer.closest('[data-free-gifts]');
      const rawTitles = freeGiftWrapper?.dataset.nonStackableDiscounts || '';

      return rawTitles
        .split(/[\n,]+/)
        .map(normalizeDiscountTitle)
        .filter(Boolean);
    }

    function appliedDiscountTitles(cart) {
      const titles = [];

      cart.cart_level_discount_applications?.forEach(discount => {
        titles.push(discount.title);
      });

      cart.items?.forEach(item => {
        item.line_level_discount_allocations?.forEach(allocation => {
          titles.push(allocation.discount_application?.title);
        });

        item.discounts?.forEach(discount => {
          titles.push(discount.title);
        });
      });

      return titles.map(normalizeDiscountTitle).filter(Boolean);
    }

    function hasNonStackableDiscountApplied(cart, offer) {
      const blockedTitles = nonStackableDiscountTitles(offer);
      if (!blockedTitles.length) return false;

      const activeTitles = appliedDiscountTitles(cart);
      return activeTitles.some(title => blockedTitles.includes(title));
    }

    async function fetchCartJson() {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      return res.json();
    }

    async function addGiftVariant(variantId) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.warn('Gift could not be added:', err);
      }
    }

    async function updateFreeGiftOffersUI() {
      const offer = cartDrawer.querySelector('[data-free-gift-offer]');
      if (!offer) return;

      const variantId = Number(offer.dataset.variantId);
      const thresholdCents = Number(offer.dataset.minSpendCents);

      const headerPre = offer.querySelector('[data-free-gift-header-pre]');
      const headerUnlocked = offer.querySelector('[data-free-gift-header-unlocked]');
      const remainingEl = offer.querySelector('[data-free-gift-remaining]');
      const btn = offer.querySelector('[data-free-gift-accept]');

      const cart = await fetchCartJson();
      const subtotal = eligibleSubtotalCents(cart, variantId);
      const eligible = subtotal >= thresholdCents;
      const hasGift = cart.items.some(i => Number(i.variant_id) === variantId);
      const hasBlockedDiscount = hasNonStackableDiscountApplied(cart, offer);

      if (hasGift || hasBlockedDiscount) {
        offer.classList.add('hidden');
        return;
      }

      offer.classList.remove('hidden');

      if (eligible) {
        // ✅ UNLOCKED
        headerPre?.classList.add('hidden');
        headerUnlocked?.classList.remove('hidden');

        if (btn) {
          btn.classList.remove('is-hidden');
          btn.disabled = false;
        }
      } else {
        // 🔒 PRE‑UNLOCK
        headerUnlocked?.classList.add('hidden');
        headerPre?.classList.remove('hidden');

        if (btn) {
          btn.classList.add('is-hidden');
          btn.disabled = true;
        }

        const remaining = Math.max(0, thresholdCents - subtotal);
        if (remainingEl) remainingEl.textContent = formatMoney(remaining);
      }
    }

    function initFreeGiftOffers() {
      const offer = cartDrawer.querySelector('[data-free-gift-offer]');
      if (!offer) return;

      const btn = offer.querySelector('[data-free-gift-accept]');
      if (btn && !btn.dataset.bound) {
        btn.dataset.bound = 'true';

        btn.addEventListener('click', async () => {
          if (btn.classList.contains('is-loading') || btn.disabled) return;

          btn.classList.add('is-loading');

          try {
            await addGiftVariant(offer.dataset.variantId);
            fetchCartContent(); // re-render → free gift block disappears
          } catch (e) {
            console.error('Free gift add failed', e);
            btn.classList.remove('is-loading');
          }
        });
      }

      // ✅ THIS IS THE MISSING PIECE
      updateFreeGiftOffersUI();
    }

    ////////////////////////////////////////////////////////
    // Cross-sell offers – show offer when eligible, add on click
    ////////////////////////////////////////////////////////
    async function addCrossSellVariant(variantId, position) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
              properties: {
                _cart_upsell: `position:${position}`
              }
            }
          ]
        })
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.warn('Cross-sell could not be added:', err);
        throw new Error('Cross-sell add failed');
      }

      return res.json();
    }


    function updateCrossSellNavState(wrapper) {
      const track = wrapper.querySelector('[data-cross-sell-track]');
      const leftBtn = wrapper.querySelector('[data-cross-sell-nav="left"]');
      const rightBtn = wrapper.querySelector('[data-cross-sell-nav="right"]');
      const leftFade = wrapper.querySelector('.cross-sell-fade--left');
      const rightFade = wrapper.querySelector('.cross-sell-fade--right');

      if (!track || !leftBtn || !rightBtn) return;

      const scrollLeft = track.scrollLeft;
      const maxScroll = track.scrollWidth - track.clientWidth;

      const atStart = scrollLeft <= 5;
      const atEnd = scrollLeft >= maxScroll - 5;
      const hasOverflow = track.scrollWidth > track.clientWidth;

      /* Arrow states */
      leftBtn.classList.toggle('is-disabled', atStart);
      rightBtn.classList.toggle('is-disabled', atEnd);

      /* Fade states */
      if (leftFade) {
        leftFade.classList.toggle('is-visible', hasOverflow && !atStart);
      }

      if (rightFade) {
        rightFade.classList.toggle('is-visible', hasOverflow && !atEnd);
      }

      /* Hide arrows if there is nothing to scroll */
      if (!hasOverflow) {
        leftBtn.style.display = 'none';
        rightBtn.style.display = 'none';
      } else {
        leftBtn.style.display = '';
        rightBtn.style.display = '';
      }
    }

});
